export const faqs = [
  {
    q: "深夜吃瓜是一个什么样的社区？",
    a: "我们把全网正在发酵的热话题集中起来，为每个话题开设一个专属讨论区。你可以先看完整的来龙去脉，再围观别人怎么想，最后发表自己的看法。它不是新闻资讯站，也不是纯粹的评论区，而是一个让观点真正碰面的地方。",
  },
  {
    q: "每个话题的讨论区里都有什么？",
    a: "话题正文会梳理事件的时间线和关键信息，下面列出「关键看点」方便快速抓重点。再往下是观点楼层，按热度或最新排列，你可以对任意一条观点点赞、回复，也可以直接开一层新的讨论。",
  },
  {
    q: "发评论需要注册账号吗？",
    a: "当前阶段不需要。你可以直接以昵称发表观点，评论会保存在本地会话中，刷新页面后恢复初始状态。后续如果开放账号体系，我们会在站内提前公告。",
  },
  {
    q: "为什么话题里的人物看起来都很陌生？",
    a: "为了让讨论聚焦在「现象和观点」本身，站内所有话题中的人物、机构、作品均为虚构化名。我们更希望你来聊「这件事说明了什么」，而不是「那个人到底是谁」。",
  },
  {
    q: "社区鼓励什么样的发言？",
    a: "鼓励有信息量、有逻辑的表达，比如补充事实、提出质疑、给出不同视角。不鼓励人身攻击、无依据的揣测和纯情绪宣泄。观点可以尖锐，但请对准事情，不要对准个人。",
  },
  {
    q: "热榜的排名是怎么算出来的？",
    a: "综合话题的浏览量、评论数、点赞密度和近期讨论增速计算得出，分今日、本周、本月三个维度展示。热度是动态变化的，越靠近当下发生的讨论，权重越高。",
  },
  {
    q: "如何向社区推荐一个话题？",
    a: "可以通过「关于我们」页面留的邮箱联系我们，说明话题的基本情况和讨论价值。如果它足够有聊头，我们会把它做成一个完整的讨论区。",
  },
  {
    q: "在社区里可以发布商业推广内容吗？",
    a: "不可以。站内不承接任何形式的广告投放，也不接受在讨论区发布导流、带货和刷屏内容。我们希望这里保持干净，讨论区的每一层都值得读。",
  },
];